import { ProductFilter } from "./ProductFilter";
import ProductCard from "./ProductCard";

import { useState, Fragment } from "react";

import InfiniteScrollTrigger from "@shared/components/InfiniteScrollTrigger";
import { useProductsInfiniteQuery } from '@features/products/hooks/useProducts';
import { toast } from "sonner";
import ThreeDotLoader from "@shared/components/ThreeDotLoader";

const ProductList = () => {
  const [params, setParams] = useState({ limit: 10, isActive: true });

  const {
    status,
    data,
    error,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useProductsInfiniteQuery(params);

  const handleFilter = (filter) => {
    setParams({ ...params, ...filter });
  };

  if (status === "error") return toast.error(`Error: ${error.message}`);

  return (
    <>
      <ProductFilter onFilter={handleFilter} params={params} />

      {isLoading ? (
        <div className="w-full flex items-center justify-center">
          <ThreeDotLoader />
        </div>
      ) : (
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {data?.pages?.map((page) => (
              <Fragment key={page.pageInfo.currentPage}>
                {page.data.map((product) => (
                  <ProductCard
                    product={product}
                    key={product._id}
                    className={
                      "transition-transform duration-300 hover:scale-99 hover:bg-background/40"
                    }
                  />
                ))}
              </Fragment>
            ))}
          </div>
          <InfiniteScrollTrigger
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
          />
        </div>
      )}
    </>
  );
};

export default ProductList;
